import React, { useEffect, useState } from "react";
import { PageProps } from "gatsby";
import { ethers, BigNumber } from "ethers";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Home from "../components/pages/lading-page/body";
import Toast from "../components/toast";
// import Habitats from "../../abis/rinkeby/Habitats.json";
import Habitats from "../../abis/mainnet/Habitats.json";

const MAINNET_NETWORK_ID = 1;

const HomePage: React.FC<PageProps> = pageProps => {
  const [account, setAccount] = useState<string | null>(null);
  const [contract, setContract] = useState<any | null>(null);
  const [totalSupply, setTotalSupply] = useState<number | null>(null);
  const [curSaleState, setCurSaleState] = useState<number | null>(null);
  const [shouldShowError, setShouldShowError] = useState<boolean>(false);
  const [isMainnet, setIsMainnet] = useState<boolean>(true); // TODO (Ben): Change this to false when done testing

  const [connectButtonElement, setConnectButtonElement] = useState<HTMLButtonElement | undefined>(undefined);

  const getAndSetAccount = async () => {
    if (typeof window !== 'undefined' && window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum || 'http://127.0.0.1:8545');
      const addresses = await provider.listAccounts();
      const address = addresses[0] as string;
      setAccount(address ? ethers.utils.getAddress(address) : address);
    }
  };

  useEffect(() => {
    const setupWeb3Info = async () => {
      if (typeof window !== 'undefined' && window.ethereum) {
        const provider = new ethers.providers.Web3Provider(window.ethereum || 'http://127.0.0.1:8545');

        const { chainId } = await provider.getNetwork();
        if (chainId !== MAINNET_NETWORK_ID) {
          setShouldShowError(true);
        } else {
          setIsMainnet(true);
        }

        const networkData = Habitats.networks[chainId];
        if (networkData) {
          const abi = Habitats.abi;
          const contractAddress = networkData.address;
          const contract = new ethers.Contract(contractAddress, abi, provider.getSigner(account ? account : undefined));
          setContract(contract);
        }

        getAndSetAccount();
      }
    }

    setupWeb3Info()
  }, [account]);

  // Get total supply from Alchemy provider
  useEffect(() => {
    const alchemyProvider = new ethers.providers.AlchemyProvider(1, 'l3Tuf7gjoikjBjEdYzV9ZobRYgmY_K9-');
    const tempContract = new ethers.Contract('0x64A733c56034569B0c08742e51204E5D545A8bDd', Habitats.abi, alchemyProvider);
    if (tempContract) {
        tempContract.totalSupply().then((supply: BigNumber) => {
          setTotalSupply(supply.toNumber());
        });

        tempContract.state().then((saleState: string) => {
          setCurSaleState(parseInt(saleState));
        });
      }
  }, []);

  return (
    <Layout pageProps={pageProps} accountAddress={account} providedGetAndSetAccount={getAndSetAccount} connectButtonElement={connectButtonElement}>
      <SEO title="Habitats" />
      {shouldShowError && (
        <Toast
          text="You're not connected to the Ethereum mainnet. You must be connected mainnet to mint."
          variant='error'
          onClose={() => {
            setShouldShowError(false);
          }}
        />
      )}

      <Home
        contract={contract}
        accountAddress={account}
        getAndSetAccount={getAndSetAccount}
        isMainnet={isMainnet}
        totalSupply={totalSupply}
        curSaleState={curSaleState}
        setConnectButtonElement={setConnectButtonElement}
      />
    </Layout>
  )
}

export default HomePage
